import packageInfo from 'package.json';

export const environment = {
  production: true,
  environment: 'PROD',
  sentry: {
    dsn: 'https://f6087aa001e7ed8d65f98c8f3f0d861d@o4507061083963392.ingest.de.sentry.io/4510238089871440',
    packageName: packageInfo.name,
    packageVersion: packageInfo.version,
  },
  api: {
    bff: '/api',
  },
};
